import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DrExerciseModule } from './dr-exercise/dr-exercise.module';

const routes: Routes = [
  {
    path: 'bcp',
    data: { breadcrumb: 'Testing', labelId: 'L_SA_Testing' },
    loadChildren: () =>
      import('./bcp-testing/bcp-testing.module').then(
        (m) => m.BcpTestingModule
      ),
  },

  {
    path: 'table-top',
    data: { breadcrumb: 'Testing', labelId: 'L_SA_Testing' },
    loadChildren: () =>
      import('./table-top/table-top.module').then((m) => m.TableTopModule),
  },

  {
    path: 'dr-exercise',
    data: {
      breadcrumb: 'DR Exercise',
      labelId: 'L_DISASTER_MANAGEMENT_EXERCISES',
    },
    loadChildren: () =>
      import('./dr-exercise/dr-exercise.module').then(
        (m) => m.DrExerciseModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TestingRoutingModule {}
